import spinModel from "../../../../vendor_core/core/src/model/SpinModel";
import { ICondition } from "../../../../vendor_core/core/src/states/State";

export default class VOEFreeSpinsWonCondition implements ICondition {
    public check(): boolean {
        let test =  spinModel.hasFreespinsWon();

        return spinModel.hasFreespinsWon();
    }
}